<template>
  <section class="container d-flex flex-column mt-5">
    <img
      src="/assets/img/game_resources/cover.jpg"
      class="mb-3"
      alt="Legendary Battles"
    />
    <h3 class="text-center">História</h3>

    <p class="text-justify">
      Bem vindo(a) à Luehn, um mundo mágico onde mares, rios, montanhas,
      pântanos, florestas, planícies e desertos são habitados pelos mais
      diversos seres. Humanos, gigantes, elfos, anjos, demônios, entre outros
      seres, todos vivendo em conjunto e formando os quatro reinos de Luehn:
      Dion, o reino do Norte; Mein, o reino do Sul; Vultor, o reino do Leste e
      Zeth, o reino do Oeste. Após a Primeira Grande Guerra dos Reinos, quando
      Kukoh, o Domador de Almas, foi derrotado, os quatro reinos assinaram o
      Pacto de Paz. Mas após 1300 anos, conflitos e pequenos problemas entre os
      reinos foram aumentando. O Pacto de Paz foi despedaçado, dando origem à
      Segunda Grande Guerra dos Reinos.
    </p>

    <p class="text-justify">
      A Segunda Grande Guerra se alastrou e as batalhas e conflitos chegaram em
      todo o mundo de Luehn. De pequenos vilarejos às grandes cidades, o som dos
      tambores, gritos de guerra e o cheiro do sangue preenchem cada hora do dia
      e cada pedaço dos reinos.
    </p>

    <h3 class="text-center mt-5">Introdução</h3>

    <p class="text-justify">
      Em <strong>Torn: Legendary Battles</strong>, você toma o papel de um
      estrategista de combate. Podendo contar com o poder de todos os seres que
      vivem no mundo de Luehn, você deve usar suas habilidades para liderar seus
      combatentes à vitória. Cada batalha travada pode ser a última, então
      pense, monte estratégias e comande seus combatentes em batalhas épicas
      nesse mundo mágico.
    </p>

    <h3 class="text-center mt-5">Artes</h3>

    <p class="text-justify">
      Todas as artes para o jogo foram desenhadas à mão pelo meu amigo
      <a
        href="https://instagram.com/protocosmic.art"
        target="_blank"
        rel="noreferrer"
      >
        Constantino </a
      >.
    </p>

    <p class="text-justify">
      Acesse o link abaixo para fazer download das artes para imprimir e jogar
      com seus amigos.
    </p>

    <p class="text-center">
      <a class="gumroad-button" href="https://gum.co/TLBPP?wanted=true">
        Download
      </a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'home'
}
</script>
